import React from 'react'
import { t, Trans } from '@lingui/macro'
import { observer } from 'mobx-react-lite'
import { Card } from '@odiupsk/up-api-client'
import { _ } from '../../common/utils/intl'
import {
  Button,
  ButtonLayout,
  DialogContent,
  DialogFooter,
  DialogHeader,
  ReachDialog,
} from '../../common/ui-kit'

export const NfcCodeModal: React.FC<{
  card: Card
  close: () => void
}> = observer(({ card, close }) => {
  return (
    <ReachDialog onDismiss={close} size="xxlarge">
      <DialogHeader title={_(t`Up Déjeuner NFC – Android aktivácia`)} />
      <DialogContent className="mb-large">
        <h3 className="text-default text-bold mb">
          {/* @ts-ignore */}
          <Trans>Aktivačný kód</Trans>: {card.nfc_code}
        </h3>

        <div className="text-color-black">
          <Trans>
            Aktivujte si funkciu <strong>NFC</strong> pre svoju kartu <strong>UpDéjeuner</strong> a
            budete môcť <strong>platiť mobilom s OS Android</strong> v prevádzkach, kde ju
            akceptujú.
          </Trans>
          <br />
          <br />
        </div>

        <h3 className="text-default text-bold mb">
          <Trans>Čo potrebujete k aktivácii:</Trans>:
        </h3>

        <ul>
          <li className="text-small">
            <Trans>Kartu UpDéjeuner</Trans>
          </li>
          <li className="text-small">
            <Trans>Android telefón s NFC</Trans>
          </li>
          <li className="text-small">
            <Trans>
              Aplikáciu{' '}
              <a
                className="link-black text-small"
                target="_BLANK"
                href="https://play.google.com/store/apps/details?id=sk.upsk.slovensko"
                rel="noopener noreferrer">
                Zóna Up
              </a>{' '}
              vo verzii 1.0.16 a vyššej
            </Trans>
          </li>
          <li className="text-small">
            <Trans>Aktivačný kód pre NFC zobrazený tu hore</Trans>
          </li>
        </ul>

        {/* <h3 className="text-default text-bold mb">
          <Trans>Kde nájdete aktivačný kód</Trans>:
        </h3>

        <ul>
          <li className="text-small">
            <Trans>
              V zóne Moja karta a aj v aplikácii Moja karta (POZOR! Len v novej verzii z{' '}
              <a
                href="https://play.google.com/store/apps/details?id=upSlovensko.androidApp"
                target="_blank"
                rel="noopener noreferrer"
                className="link-black text-small">
                ObchodPlay
              </a>
              )
            </Trans>
          </li>
          <li className="text-small">
            <Trans>Na sprievodnom liste k novej karte pre karty vydané po 15. 6. 2020</Trans>
          </li>
        </ul> */}

        {/* <h3 className="text-default text-bold mb">
          <Trans>Ako zaplatiť kartou UpDéjeuner v mobile</Trans>:
        </h3>

        <ul>
          <li className="text-small">
            <Trans>
              Uistite sa, že váš mobilný telefón s operačným systémom Android 4.4. a viac podporuje
              technológiu NFC, a že je zapnutá
            </Trans>
          </li>
          <li className="text-small">
            <Trans>Stravovacia karta musí byť platná a aktivovaná.</Trans>
          </li>
          <li className="text-small">
            <Trans>
              S Up Déjeuner NFC môžete platiť všade tam, kde vidíte symbol o akceptácii kariet
              UpDéjeuner.
            </Trans>
          </li>
          <li className="text-small">
            <Trans>
              Odblokujte displej svojho mobilného telefónu, zapnite funkciu NFC a priložte telefón k
              POS terminálu. Výsledok platby sa zobrazí na POS termináli, ktorý vytlačí potvrdenie o
              platbe.
            </Trans>
          </li>
          <li className="text-small">
            <Trans>V prípade platby do 50 EUR nie je potrebné zadávať PIN kód.</Trans>
          </li>
          <li className="text-small">
            <Trans>
              V prípade platby nad 50 EUR je potrebné sledovať pokyny na obrazovke POS terminálu a
              po výzve zadať PIN kód.
            </Trans>
          </li>
          <li className="text-small">
            <Trans>
              Aplikácia Up Déjeuner NFC je bezplatná a môžete si ju nahrať do telefónu cez{' '}
              <a
                href="https://play.google.com/store/apps/details?id=com.aheaditec.hce.chequeSk"
                target="_blank"
                rel="noopener noreferrer"
                className="link-black text-small">
                tento odkaz
              </a>
            </Trans>
          </li>
        </ul> */}

        <h3 className="text-default text-bold mb">
          <Trans>Postup</Trans>:
        </h3>

        <ol>
          <li className="text-small">
            <Trans>
              Overte si verziu Zóny Up v <strong>Môj profil {'->'} Nastavenia</strong> (ozubené
              koliesko) <strong>{'->'} O aplikácii</strong>
              <br />
              Ak máte nižšiu verziu ako 1.0.16., odinštalujte ju a znovu nainštalujte.
              (funkcionalita NFC sa totiž nachádza až v novších verziách aplikácie Zóna Up 1.0.16)
            </Trans>
          </li>
          <li className="text-small">
            <Trans>
              Ak ste využívali pôvodnú samostatnú aplikáciu{' '}
              <a
                className="link-black text-small"
                href="https://play.google.com/store/apps/details?id=com.aheaditec.hce.chequeSk"
                target="_BLANK"
                rel="noopener noreferrer">
                Up Déjeuner NFC
              </a>
              , deaktivujte v nej svoju kartu a odinštalujte si ju.
            </Trans>
          </li>
          <li className="text-small">
            <Trans>
              Aktivujte si NFC pre kartu UpDéjeuner. Pri platení mobilom si potom vo svojom telefóne
              zapnite funkciu NFC a zvoľte kartu UpDéjeuner.
            </Trans>
          </li>
        </ol>
      </DialogContent>
      <DialogFooter>
        <ButtonLayout direction="horizontal" className="align-items-right">
          <Button onClick={close}>
            <Trans>Zatvoriť</Trans>
          </Button>
        </ButtonLayout>
      </DialogFooter>
    </ReachDialog>
  )
})

NfcCodeModal.displayName = 'NfcCodeModal'
